import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { debounceTime, Subject } from "rxjs";
import {
  ButtonComponent,
  ButtonVariant,
} from "src/app/common/components/core/button/button.component";
import { ConfirmationModalComponent } from "src/app/common/components/core/modal/confirmation-modal/confirmation-modal.component";
import { AppConstants } from "src/app/common/constants/app-constants";
import { CharacterRestrictionError } from "src/app/common/constants/documentation-constants";
import { Features } from "src/app/common/enums/features.enum";
import { ListBase } from "src/app/common/interfaces/list-base.interface";
import { SecurityFeatureUtility } from "src/app/common/services/security-feature.utility";
import { CommonModule, NgIf } from "@angular/common";
@Component({
  selector: "app-cosign-search",
  templateUrl: "./cosign-search.component.html",
  styleUrls: ["./cosign-search.component.scss"],
  imports: [ButtonComponent, FormsModule, MatFormFieldModule,NgIf],
  standalone: true,
})
export class CosignSearchComponent {
  searchText: string = "";
  keyword: string = "";
  private _props!: ListBase;
  private searchSubject: Subject<string> = new Subject<string>();
  @Output() signClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() searchClicked: EventEmitter<{
    searchBy?: string;
    keyword: string;
  }> = new EventEmitter();
  @Input() defaultField?: string = undefined;
  @Input() isEnable: boolean = false;
  @Input()
  set props(value: ListBase) {
    if (value) {
      this._props = value;
      this.updateColumnDef();
    }
  }
  get childProps() {
    return this.props;
  }
  buttonVariant = ButtonVariant;
  canAccess: boolean = false;

  constructor(
    private dialog: MatDialog,
    private securityFeatureUtility: SecurityFeatureUtility
  ) {
    this.searchSubject.pipe(debounceTime(800)).subscribe((value: any) => {
      this.searchClicked.emit({ keyword: value });
    });
  }

  ngOnInit() {
    this.canAccess =
      this.securityFeatureUtility.getSecurityFeature(Features.CO_SIGN, false)
        ?.featureaccess === AppConstants.manage;
  }

  typed(event: KeyboardEvent) {
    const value = this.searchText.trim();
    if (value.length > 2) {
      this.searchSubject.next(value);
    }
    else{
      this.searchSubject.next("");
    }
  }
  private updateColumnDef() {
    if (this._props?.columnDefs) {
      this._props.columnDefs = this._props.columnDefs.map((colDef) => ({
        ...colDef,
        suppressMenu: true,
      }));
    }
  }
  onClickSign() {
    if(this.isEnable){
      this.isEnable=false;
      this.signClicked.emit();
    }
  }
}
